


















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';
import Datepicker from 'vuejs-datepicker';
import {sv} from 'vuejs-datepicker/dist/locale';

@Component({components: {Toggle, List, Datepicker}})
export default class Intro extends Vue {
  @Prop() readonly group!: any;

  rows: any = [];

  @Watch('section', {immediate: true, deep: true})
  onData() {
    this.init();
    if (this.section.Items) {
      for (let i = 0; i < this.section.Items.length; i++) {
        const s = this.section.Items[i];
        this.rows[i].Date = s.Date;
        this.rows[i].Text = s.Text;
      }
    }
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  @Watch('rows', { immediate: false, deep: true })
  rowsChanged() {
    if (JSON.stringify(this.storeItems()) === JSON.stringify(this.rows)) {
      return;
    }
    this.update();
  }

  update() {
    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.section.SubType,
      Hidden: this.section.Hidden,
      Items: this.rows,
    };

    dokument.updateItem(s);
  }

  init() {
    this.rows = [
      { Date: '', Text: '' },
      { Date: '', Text: '' },
      { Date: '', Text: '' },
      { Date: '', Text: '' },
      { Date: '', Text: '' },
    ];
    if (this.section.Items) {
      for (let i = 0; i < this.section.Items.length - 5; i++) {
        this.rows.push({ Date: '', Text: '' });
      }
    }
  }

  storeItems() {
    if (!this.section.Items) {
      return [];
    }
    return this.section.Items;
  }

  addRow() {
    this.rows.push({ Date: '', Text: '' });
  }

  get showWarning() {
    if (!this.section.Hidden) {
      return false;
    }
    for (const row of this.rows) {
      if (row.Date || row.Text) {
        return true;
      }
    }
    return false;
  }

  get lang() {
    return sv;
  }

  get section(): any {
    return dokument.getItem(61) as any;
  }

  get hidden(): boolean {
    return this.section.Hidden;
  }

  get itemCount() {
    if (!this.section.Items) {
      return 5;
    }
    return this.section.Items.length;
  }
}
